module.exports = __webpack_public_path__ + "img/regensburg_sitzungssaal.e6d0458f.jpg";